import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// Styles
import { getFontWeight } from "../../../styles/font-weight";
import { colors } from "../../../styles/colors";

export const Samurai = () => {
  return (
    <StyledLink href="https://misaky.tokyo/pages/about">
      <StyledDivRootContainer>
        <StyledDivSentence>The same experience that amazed</StyledDivSentence>
        <StyledDivWhiteBox />
        <StyledDivSentence>Samurai in Japan 400 years ago</StyledDivSentence>
      </StyledDivRootContainer>
    </StyledLink>
  );
};

const StyledLink = styled.a`
  text-decoration: none;
`;

const StyledDivRootContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${require("../../../assets/images/samurai.png")});
  background-size: cover;
  color: ${colors.white};
  ${getFontWeight("Heavy")};

  ${media.lessThan("medium")`
    height: 250px;
  `};

  ${media.greaterThan("medium")`
    height: 500px;
  `}
`;

const StyledDivWhiteBox = styled.div`
  width: 100%;
  height: 8px;
`;

const StyledDivSentence = styled.div`
  ${media.lessThan("medium")`
    font-size: 16px;
  `};

  ${media.greaterThan("medium")`
    font-size: 40px;
  `}
`;
